module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-de-0e196a2128d20f3d72bcc5c09d3bbf16.svg";